// データがない場合の表示テキスト
export const NON_DATA_TEXT = "--";

// 曜日
export const YOUBI_LIST = ["日", "月", "火", "水", "木", "金", "土"];
